import * as React from "react";
import {css, cx} from "@panda/css";

import {CityIcon, MapMarkerOutlineIcon} from "@pg-design/icons-module";
import {Text, TextVariantUnionType} from "@pg-design/text-module";

import {getPropertyDistance, getPropertyLocation} from "../../helpers/quick_view/set_property_info";

interface IProps {
    address: string;
    offerType: number;
    distanceFromRegion?: {
        center: boolean;
        region: string;
        distance: number;
    };
    className?: string;
    textVariant?: TextVariantUnionType;
}

export const QWLocalizationInfo = (props: IProps) => {
    const {offerType, address, distanceFromRegion} = props;

    return (
        <div className={cx(localizationInfo, props.className)}>
            <div className={css({display: "flex", alignItems: "flex-start"})}>
                <MapMarkerOutlineIcon className={css({mr: 1})} size="2.4" fill="var(--colors-gray-700)" />

                <Text as="div" variant={props.textVariant || "info_txt_2"} mb={2}>
                    <span>{getPropertyLocation(offerType, address)}</span>
                </Text>
            </div>
            {distanceFromRegion && (
                <div className={css({display: "flex", alignItems: "flex-start"})}>
                    <CityIcon className={css({mr: 2})} size="2.4" fill="var(--colors-gray-700)" />

                    <Text as="div" variant={props.textVariant || "info_txt_2"} mb={2}>
                        <span>{getPropertyDistance(distanceFromRegion)}</span>
                    </Text>
                </div>
            )}
        </div>
    );
};
const localizationInfo = css({
    color: "var(--colors-gray-700)",
    pl: "0.6rem",
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "column"
});
import * as React from "react";
import {css, cx} from "@panda/css";

import {CityIcon, MapMarkerOutlineIcon} from "@pg-design/icons-module";
import {Text, TextVariantUnionType} from "@pg-design/text-module";

import {getPropertyDistance, getPropertyLocation} from "../../helpers/quick_view/set_property_info";

interface IProps {
    address: string;
    offerType: number;
    distanceFromRegion?: {
        center: boolean;
        region: string;
        distance: number;
    };
    className?: string;
    textVariant?: TextVariantUnionType;
}

export const QWLocalizationInfo = (props: IProps) => {
    const {offerType, address, distanceFromRegion} = props;

    return (
        <div className={cx(localizationInfo, props.className)}>
            <div className={css({display: "flex", alignItems: "flex-start"})}>
                <MapMarkerOutlineIcon className={css({mr: 1})} size="2.4" fill="var(--colors-gray-700)" />

                <Text as="div" variant={props.textVariant || "info_txt_2"} mb={2}>
                    <span>{getPropertyLocation(offerType, address)}</span>
                </Text>
            </div>
            {distanceFromRegion && (
                <div className={css({display: "flex", alignItems: "flex-start"})}>
                    <CityIcon className={css({mr: 2})} size="2.4" fill="var(--colors-gray-700)" />

                    <Text as="div" variant={props.textVariant || "info_txt_2"} mb={2}>
                        <span>{getPropertyDistance(distanceFromRegion)}</span>
                    </Text>
                </div>
            )}
        </div>
    );
};
const localizationInfo = css({
    color: "var(--colors-gray-700)",
    pl: "0.6rem",
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "column"
});
